import styled from 'styled-components';

import { mediaQuery } from '../../../../../styles/global';


export const Wrapper = styled.div`
  position: relative;
  padding: 0 20px;
  margin-bottom: 225px;

  ${mediaQuery.maxWidth.tablet} {
    margin-bottom: 112px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StimulateSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 120px;
  align-items: center;

  ${mediaQuery.maxWidth.tablet} {
    flex-direction: column;
    gap: 32px;
  }
`;

export const FocusSection = styled.div`
    gap: 64px;
    position: relative;

    ${mediaQuery.maxWidth.tablet} {
      margin-top: 110px;
      gap: 32px;
    }
`;

export const FocusInfoContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 64px;

    ${mediaQuery.maxWidth.tablet} {
      gap: 32px;
    }
`

export const SectionTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 50%;
  gap: 32px;

  ${mediaQuery.maxWidth.tablet} {
    width: 100%;
  }
`;

export const SectionTitle = styled.h2`
  margin: 0;
  flex: 1 0 0;
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fontFamily.bold};
  font-size: 3.5rem;
  font-weight: 700;
  line-height: 100%;

  ${mediaQuery.maxWidth.desktop} {
    font-size: 2rem;
  }
`;

export const SectionDescription = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.white75};
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-size: 1.5rem;
  font-weight: 400;

  span {
    color: ${({ theme }) => theme.colors.white};
    font-family: ${({ theme }) => theme.fontFamily.medium};
  }

  ${mediaQuery.maxWidth.desktop} {
    font-size: 1.25rem;
  }
`;

export const SectionSmallDescription = styled.p`
  margin: 0;
  flex: 1 0 0;
  color: ${({ theme }) => theme.colors.white75};
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 32px;
`;

export const StimulateImageWrapper = styled.div`
  display: block;

  ${mediaQuery.maxWidth.tablet} {
    display: none;
  }
`;

export const Image = styled.img`
  width: 100%;
`

export const MobileStimulateImageWrapper = styled.div`
  display: none;
  width: 100%;
  margin: 24px 0;

  ${mediaQuery.maxWidth.tablet} {
    display: block;
  }
`;

export const CtaWrapper = styled.div`
`;

export const ButtonLink = styled.div`
  color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 48px;
  padding: 20px 32px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: center;
  text-transform: uppercase;
  cursor: pointer;

  a,
  span {
    text-decoration: none;
    font-family: ${({ theme }) => theme.fontFamily.bold};
    letter-spacing: 1px;
    font-size: 1rem;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.white};

    ${mediaQuery.maxWidth.tablet} {
      font-size: 0.75rem;
    }
  }

  img {
    height: 24px;
    width: 24px;
  }

  &:hover {
    scale: 1.1;
    background-color: rgba(255, 255, 255, 0.15);
  }

  ${mediaQuery.maxWidth.phone} {
    width: 100%;
    font-size: 0.75rem;
    padding: 12px 32px;
  }
`;

export const FocusInfoCardsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: flex-start; 

  ${mediaQuery.maxWidth.tablet} {
    flex-direction: column;
  }
`;

export const LeftBlurImage = styled.img`
  pointer-events: none;
  position: absolute;
  left: -20px;
  top: -300px;
  max-height: 1200px;
`;

export const RightBlurImage = styled.img`
  pointer-events: none;
  position: absolute;
  right: -20px;
  top: -50%;
`;


export const ReviewsSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 175px;

  ${mediaQuery.maxWidth.tablet} {
    margin-top: 110px;
  }
`;

export const ReviewsTitle = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fontFamily.bold};
  font-size: 3.5rem;
  text-align: center;

  ${mediaQuery.maxWidth.tablet} {
    font-size: 2rem;
  }
`;

export const ReviewsDescription = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.white75};
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-size: 1.5rem;
  text-align: center;
  ${mediaQuery.maxWidth.tablet} {
    font-size: 1.25rem;
  }
`;

export const AdhdInfoContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-top: 80px;

  ${mediaQuery.maxWidth.tablet} {
    gap: 32px;
  }
`;


export const AdhdHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;

  ${mediaQuery.maxWidth.tablet} {
    flex-direction: column;
    gap: 16px;
  }
`;

export const AdhdCardsWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: flex-start;

  ${mediaQuery.maxWidth.desktop} {
    flex-direction: column;
    gap: 20px;
  }
`;

export const ScienceOfAdhdContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 72px;
  margin-top: 174px;
  align-items: flex-start;

  ${mediaQuery.maxWidth.tablet} {
    margin-top: 83px;
    gap: 32px;
  }
`;

export const ScienceOfAdhdHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ScienceOfAdhdCardsWrapper = styled.div`
  display: flex;
`;

export const ScienceOfAdhdButton = styled.div`
  display: flex;
  height: 48px;
  padding: 0px 32px;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fontFamily.bold};
  font-size: 0.75rem;
  line-height: 120%;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  border-radius: 48px;
  background: rgba(255, 255, 255, 0.10);
  border: none;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    scale: 1.1;
    background-color: rgba(255, 255, 255, 0.15);
  }
`;

export const StudyContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 64px;
  margin-top: 260px;

  ${mediaQuery.maxWidth.tablet} {
    flex-direction: column-reverse;
    margin-top: 152px;
  }
`;

export const StudyLeftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const StudyNewPeerText = styled.p`
  color: ${({ theme }) => theme.colors.white50};
  font-family: ${({ theme }) => theme.fontFamily.bold};
  font-size: 0.75rem;
  line-height: 120%;
  letter-spacing: 1.2px;
  text-transform: uppercase;
`;

export const StudyTitle = styled.h2`
  margin: 0;
  margin-top: 8px;
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fontFamily.bold};
  font-size: 3rem;
  font-weight: 700;

  ${mediaQuery.maxWidth.tablet} {
    font-size: 2rem;
  }
`;

export const StudyDescription = styled.p`
  margin: 32px 0;
  color: ${({ theme }) => theme.colors.white75};
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-size: 1rem;
  line-height: 24px;

  span {
    font-family: ${({ theme }) => theme.fontFamily.medium};
    font-style: italic;
  }
`;

export const StudyImage = styled.img`
  width: 33.5rem;
  height: 29rem;

  ${mediaQuery.maxWidth.tablet} {
    flex-direction: column-reverse;
    width: 100%;
    height: 100%;
  }
`;

export const StudyBlurImage = styled.img`
  position: absolute;
  z-index: -1;
`;

export const HelpContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 251px;

  ${mediaQuery.maxWidth.tablet} {
    margin-top: 176px;
  }
`;

export const HelpTitle = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fontFamily.bold};
  font-size: 3rem;
  font-weight: 700;
  text-align: center;
`;

export const HelpImage = styled.img`
  width: 1120px;
  height: 348px;
  object-fit: cover;

  ${mediaQuery.maxWidth.tablet} {
    width: 120%;
    height: 100%;
  }
`;

export const HelpCardsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: flex-start;
  margin-top: -56px;

  ${mediaQuery.maxWidth.tablet} {
    flex-direction: column;
    margin-top: 22px;
    gap: 20px;
  }
`;

export const SocialCardsWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-flow: column wrap;
  column-count: 2;
  align-items: center;
  margin-top: 52px;
  margin-bottom: 52px;
  max-height: 900px;
  gap: 16px;
  position: relative;

  @media (max-width: 1250px) {
    max-height: 1200px;
  }

  @media (max-width: 850px) {
    max-height: 1200px;
    margin-bottom: 32px;

    & > *:nth-child(n+5) {
      display: none;
    }
  }


  &::after {
    content: '';
    position: absolute;
    bottom: -20px;
    left: 0;
    width: 100%;
    height: 400px;
    background: linear-gradient(to top, #0D0C11 15%, rgba(13, 12, 17, 0.00) 100%);
    pointer-events: none;
  }
`;

export const TryContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 64px;

  ${mediaQuery.maxWidth.desktop} {
    flex-direction: column;
    gap: 32px;
  }
`;

export const TryImage = styled.img`
  width: 500px;
  height: 500px;

  ${mediaQuery.maxWidth.tablet} {
    width: 250px;
    height: 250px;
  }
`;

export const TrySignUpWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 31.65px;

  ${mediaQuery.maxWidth.tablet} {
    flex-direction: column;
  }
`;

export const TrySignUpForm = styled.div`
  display: flex;
  flex-direction: row;
  align-content: flex-start;
  gap: 24px;

  ${mediaQuery.maxWidth.tablet} {
    flex-direction: column;
  }
`;

export const TrySignUpFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TryTitle = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fontFamily.bold};
  font-size: 2rem;
  font-weight: 700;
`;

export const TryDescription = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.white75};
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-size: 24px;
  font-weight: 400;
  line-height: 150%;
`;


export const TryInput = styled.input`
  width: 100%;
  height: 100%;
`;

export const ListenNowButton = styled.button`
  display: flex;
  height: 66px;
  padding: 25px 56px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fontFamily.bold};
  font-size: 0.75rem;
  line-height: 120%;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  flex-shrink: 0;
  cursor: pointer;
`;

export const HowToGetStartedSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-top: 160px;
  gap: 66px;

  ${mediaQuery.maxWidth.tablet} {
    flex-direction: column;
    gap: 0;
  }
`;

export const HowToGetStartedImage = styled.img`
  height: 51.875rem;
  width: 51.875rem;
  margin-left: -80px;
  object-fit: cover;

  ${mediaQuery.maxWidth.desktop} {
    height: 35rem;
    width: 35rem;
  }

  ${mediaQuery.maxWidth.tablet} {
    width: 343px;
    height: 343px;
    margin-left: 0;
  }
`;

export const HowToGetStartedContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

export const PreferenceIconImage = styled.img`
  height: 24px;
  vertical-align: middle;
  margin: 0 4px;
`;

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 40px;
  margin-bottom: 40px;
  gap: 32px;

  ${mediaQuery.maxWidth.tablet} {
    margin-top: 24px;
    margin-bottom: 32px;
  }
`;

export const StepItem = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  z-index: 1;

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    top: calc(50% + 9px);
    left: 16px;
    width: 2px;
    height: 58px;
    background: repeating-linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.20),
      rgba(255, 255, 255, 0.20) 5px,
      transparent 5px,
      transparent 10px
    );
    z-index: -1;
  }

  &:not(:first-child)::after {
    top: calc(50%);
    height: 66px;
  }
`;

export const StepImage = styled.img`
  width: 36px;
  height: 36px;
  margin-right: 15px;
  align-items: center;
`;

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  max-width: 400px;
  gap: 4px;
`;

export const StepTitle = styled.h2`
  margin: 2px 0 0 0;
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fontFamily.medium};
  font-size: 1.5rem;
  font-weight: 700;

  ${mediaQuery.maxWidth.tablet} {
    font-size: 1.25rem;
  }
`;

export const StepDescription = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.white75};
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-size: 1.125rem;
  font-weight: 400;

  ${mediaQuery.maxWidth.tablet} {
    font-size: 1rem;
  }
`;

export const MusicTaskSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 160px;
  gap: 64px;

  ${mediaQuery.maxWidth.tablet} {
    margin-top: 110px;
    gap: 32px;
  }
`;

export const GenreSection = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const GenreContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 160px;
  gap: 64px;

  ${mediaQuery.maxWidth.tablet} {
    margin-top: 110px;
    gap: 32px;
  }
`;

export const FAQSection = styled.div`
  margin-top: 176px;
  display: flex;
  flex-direction: column;
  position: relative;

  ${mediaQuery.maxWidth.tablet} {
    margin-top: 112px;
  }
`;

export const BenefitsSections = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  overflow: hidden;
  margin-top: 160px;
  padding: 120px 80px;
  border-radius: 32px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.01) 100%);
  gap: 64px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 1px solid rgba(255, 255, 255, 0.20);
    border-radius: 32px;
    pointer-events: none;
  }

  ${mediaQuery.maxWidth.tablet} {
    padding: 48px 24px;
    flex-direction: column;
  }
`;

export const BenefitsBlurImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;

  ${mediaQuery.maxWidth.tablet} {
    height: 200px;
  }
`;

export const BenefitsSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  flex: 1;
`;

export const BenefitsIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 144px;
  height: 144px;
  background: rgba(255, 255, 255, 0.10);
  border-radius: 100%;
  border: 0.92px solid rgba(255, 255, 255, 0.10);

  ${mediaQuery.maxWidth.tablet} {
    width: 72px;
    height: 72px;
  }
`;

export const BenefitsIcon = styled.img`
  width: 80px;
  height: 80px;
  flex-shrink: 0;

  ${mediaQuery.maxWidth.tablet} {
    width: 40px;
    height: 40px;
  }
`;

export const BenefitsDescription = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.white75};
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-size: 1.5rem;
  font-weight: 400;
  text-align: center;

  span {
    color: ${({ theme }) => theme.colors.white};
    font-family: ${({ theme }) => theme.fontFamily.medium};
  }

  ${mediaQuery.maxWidth.desktop} {
    font-size: 1.25rem;
  }
`;
